(() => {
  const ZOOM_RATIO = 2;

  function getLoadingSpinner(image) {
    return image
      ?.parentElement
      ?.parentElement
      ?.querySelector('.loading__spinner');
  }

  function setLoading(image, loading) {
    const loadingSpinner = getLoadingSpinner(image);

    if (loadingSpinner) {
      loadingSpinner.classList.toggle('hidden', !loading);
    }

    if (image) {
      image.style.opacity = loading ? '50%' : '100%';
    }
  }

  function prepareOverlay(container, source) {
    container.className = 'image-magnify-full-size';
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${source}')`;
    container.style.backgroundColor =
      'var(--gradient-background)';
  }

  function moveWithHover(
    image,
    event,
    zoomRatio,
    overlay
  ) {
    if (!image || !event || !overlay) return;

    const ratio =
      image.height && image.width
        ? image.height / image.width
        : 1;

    const container = image.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;

    const xDivisor = Math.max(
      image.clientWidth / 100,
      1
    );

    const yDivisor = Math.max(
      (image.clientWidth * ratio) / 100,
      1
    );

    overlay.style.backgroundPosition =
      `${xPosition / xDivisor}% ${yPosition / yDivisor}%`;

    overlay.style.backgroundSize =
      `${Math.max(image.naturalWidth || image.width, image.clientWidth) * zoomRatio}px`;
  }

  function createOverlay(image) {
    const source = image.currentSrc || image.src;
    const overlay = document.createElement('div');
    const preloadImage = new Image();

    image
      .parentElement
      ?.querySelector('.image-magnify-full-size')
      ?.remove();

    prepareOverlay(overlay, source);
    setLoading(image, true);

    preloadImage.onload = () => {
      image.parentElement?.insertBefore(
        overlay,
        image
      );

      setLoading(image, false);
    };

    preloadImage.onerror = () => {
      setLoading(image, false);
    };

    preloadImage.src = source;

    return overlay;
  }

  function magnify(image, zoomRatio, event) {
    const overlay = createOverlay(image);

    const removeOverlay = () => {
      overlay.remove();
      setLoading(image, false);
    };

    overlay.addEventListener('click', removeOverlay);
    overlay.addEventListener(
      'mouseleave',
      removeOverlay
    );

    overlay.addEventListener(
      'mousemove',
      (moveEvent) => {
        moveWithHover(
          image,
          moveEvent,
          zoomRatio,
          overlay
        );
      }
    );

    moveWithHover(
      image,
      event,
      zoomRatio,
      overlay
    );
  }

  function enableZoomOnHover(zoomRatio) {
    /*
     * Delegação de eventos: imagens inseridas depois da troca do produto
     * no kit também recebem o zoom, sem precisar executar o arquivo de novo.
     */
    document.addEventListener('click', (event) => {
      const image = event.target.closest?.(
        '.image-magnify-hover'
      );

      if (!image) return;

      magnify(image, zoomRatio, event);
    });
  }

  if (!window.__ecomhardMagnifyInitialized) {
    window.__ecomhardMagnifyInitialized = true;
    enableZoomOnHover(ZOOM_RATIO);
  }
})();
